var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _vm.$store.state.recipe
      ? _c(
          "div",
          {
            staticClass: "header",
            class: { responsive: _vm.$store.state.recipe.image },
          },
          [
            _vm.$store.state.recipe.image
              ? _c("div", { staticClass: "image" }, [_c("RecipeImages")], 1)
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "meta" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$store.state.recipe.name))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "details" },
                [
                  _vm.recipe.keywords.length
                    ? _c("div", [
                        _vm.recipe.keywords.length
                          ? _c(
                              "ul",
                              _vm._l(
                                _vm.recipe.keywords,
                                function (keyword, idx) {
                                  return _c("RecipeKeyword", {
                                    key: "keyw" + idx,
                                    attrs: {
                                      name: keyword,
                                      "title":// prettier-ignore
                                _vm.t('cookbook','Search recipes with this keyword'),
                                    },
                                    on: {
                                      "keyword-clicked": function ($event) {
                                        return _vm.keywordClicked(keyword)
                                      },
                                    },
                                  })
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "dates" }, [
                    _vm.showCreatedDate
                      ? _c(
                          "span",
                          {
                            staticClass: "date",
                            attrs: { title: _vm.t("cookbook", "Date created") },
                          },
                          [
                            _c("span", {
                              staticClass: "icon-calendar-dark date-icon",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "date-text" }, [
                              _vm._v(_vm._s(_vm.recipe.dateCreated)),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showModifiedDate
                      ? _c(
                          "span",
                          {
                            staticClass: "date",
                            attrs: {
                              title: _vm.t("cookbook", "Last modified"),
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "icon-rename date-icon",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "date-text" }, [
                              _vm._v(_vm._s(_vm.recipe.dateModified)),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("VueShowdown", {
                    staticClass: "markdown-description",
                    attrs: { markdown: _vm.recipe.description },
                  }),
                  _vm._v(" "),
                  _vm.$store.state.recipe.url
                    ? _c("p", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.t("cookbook", "Source")) + ": "),
                        ]),
                        _c(
                          "a",
                          {
                            staticClass: "source-url",
                            attrs: {
                              target: "_blank",
                              href: _vm.$store.state.recipe.url,
                            },
                          },
                          [_vm._v(_vm._s(_vm.$store.state.recipe.url))]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.t("cookbook", "Servings")) + ": "),
                    ]),
                    _vm._v(
                      _vm._s(_vm.$store.state.recipe.recipeYield) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "times" },
                [
                  _vm.recipe.timerPrep
                    ? _c("RecipeTimer", {
                        attrs: {
                          value: _vm.recipe.timerPrep,
                          phase: "prep",
                          timer: false,
                          label: "Preparation time",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recipe.timerCook
                    ? _c("RecipeTimer", {
                        attrs: {
                          value: _vm.recipe.timerCook,
                          phase: "prep",
                          timer: true,
                          label: "Cooking time",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recipe.timerTotal
                    ? _c("RecipeTimer", {
                        attrs: {
                          value: _vm.recipe.timerTotal,
                          phase: "total",
                          timer: false,
                          label: "Total time",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$store.state.recipe
      ? _c("div", { staticClass: "content" }, [
          _c("section", [
            _c("aside", [
              _c("section", [
                _vm.recipe.ingredients.length
                  ? _c("h3", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.t("cookbook", "Ingredients")) +
                          "\n                    "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.recipe.ingredients.length
                  ? _c(
                      "ul",
                      _vm._l(
                        _vm.recipe.ingredients,
                        function (ingredient, idx) {
                          return _c("RecipeIngredient", {
                            key: "ingr" + idx,
                            attrs: {
                              ingredient: ingredient,
                              "recipe-ingredients-have-subgroups":
                                _vm.recipeIngredientsHaveSubgroups,
                            },
                          })
                        }
                      ),
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("section", [
                _vm.recipe.tools.length
                  ? _c("h3", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.t("cookbook", "Tools")) +
                          "\n                    "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.recipe.tools.length
                  ? _c(
                      "ul",
                      _vm._l(_vm.recipe.tools, function (tool, idx) {
                        return _c("RecipeTool", {
                          key: "tool" + idx,
                          attrs: { tool: tool },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.showNutritionData
                ? _c("section", [
                    _c("h3", [
                      _vm._v(
                        _vm._s(_vm.t("cookbook", "Nutrition Information"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "nutrition-items" },
                      [
                        "servingSize" in _vm.recipe.nutrition &&
                        !_vm.isNullOrEmpty(_vm.recipe.nutrition["servingSize"])
                          ? _c("recipe-nutrition-info-item", {
                              attrs: {
                                title: _vm.t("cookbook", "Serving Size"),
                                data: _vm.recipe.nutrition["servingSize"],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        "calories" in _vm.recipe.nutrition &&
                        !_vm.isNullOrEmpty(_vm.recipe.nutrition["calories"])
                          ? _c("recipe-nutrition-info-item", {
                              attrs: {
                                title: _vm.t("cookbook", "Energy"),
                                data: _vm.recipe.nutrition["calories"],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        "sugarContent" in _vm.recipe.nutrition &&
                        !_vm.isNullOrEmpty(_vm.recipe.nutrition["sugarContent"])
                          ? _c("recipe-nutrition-info-item", {
                              attrs: {
                                title: _vm.t("cookbook", "Sugar"),
                                data: _vm.recipe.nutrition["sugarContent"],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        "carbohydrateContent" in _vm.recipe.nutrition &&
                        !_vm.isNullOrEmpty(
                          _vm.recipe.nutrition["carbohydrateContent"]
                        )
                          ? _c("recipe-nutrition-info-item", {
                              attrs: {
                                title: _vm.t("cookbook", "Carbohydrate"),
                                data: _vm.recipe.nutrition[
                                  "carbohydrateContent"
                                ],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        "cholesterolContent" in _vm.recipe.nutrition &&
                        !_vm.isNullOrEmpty(
                          _vm.recipe.nutrition["cholesterolContent"]
                        )
                          ? _c("recipe-nutrition-info-item", {
                              attrs: {
                                title: _vm.t("cookbook", "Cholesterol"),
                                data: _vm.recipe.nutrition[
                                  "cholesterolContent"
                                ],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        "fiberContent" in _vm.recipe.nutrition &&
                        !_vm.isNullOrEmpty(_vm.recipe.nutrition["fiberContent"])
                          ? _c("recipe-nutrition-info-item", {
                              attrs: {
                                title: _vm.t("cookbook", "Fiber"),
                                data: _vm.recipe.nutrition["fiberContent"],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        "proteinContent" in _vm.recipe.nutrition &&
                        !_vm.isNullOrEmpty(
                          _vm.recipe.nutrition["proteinContent"]
                        )
                          ? _c("recipe-nutrition-info-item", {
                              attrs: {
                                title: _vm.t("cookbook", "Protein"),
                                data: _vm.recipe.nutrition["proteinContent"],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        "sodiumContent" in _vm.recipe.nutrition &&
                        !_vm.isNullOrEmpty(
                          _vm.recipe.nutrition["sodiumContent"]
                        )
                          ? _c("recipe-nutrition-info-item", {
                              attrs: {
                                title: _vm.t("cookbook", "Sodium"),
                                data: _vm.recipe.nutrition["sodiumContent"],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        "fatContent" in _vm.recipe.nutrition &&
                        !_vm.isNullOrEmpty(_vm.recipe.nutrition["fatContent"])
                          ? _c("recipe-nutrition-info-item", {
                              attrs: {
                                title: _vm.t("cookbook", "Fat total"),
                                data: _vm.recipe.nutrition["fatContent"],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        "saturatedFatContent" in _vm.recipe.nutrition &&
                        !_vm.isNullOrEmpty(
                          _vm.recipe.nutrition["saturatedFatContent"]
                        )
                          ? _c("recipe-nutrition-info-item", {
                              attrs: {
                                title: _vm.t("cookbook", "Saturated Fat"),
                                data: _vm.recipe.nutrition[
                                  "saturatedFatContent"
                                ],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        "unsaturatedFatContent" in _vm.recipe.nutrition &&
                        !_vm.isNullOrEmpty(
                          _vm.recipe.nutrition["unsaturatedFatContent"]
                        )
                          ? _c("recipe-nutrition-info-item", {
                              attrs: {
                                title: _vm.t("cookbook", "Unsaturated Fat"),
                                data: _vm.recipe.nutrition[
                                  "unsaturatedFatContent"
                                ],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        "transFatContent" in _vm.recipe.nutrition &&
                        !_vm.isNullOrEmpty(
                          _vm.recipe.nutrition["transFatContent"]
                        )
                          ? _c("recipe-nutrition-info-item", {
                              attrs: {
                                title: _vm.t("cookbook", "Trans Fat"),
                                data: _vm.recipe.nutrition["transFatContent"],
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.recipe.instructions.length
              ? _c("main", [
                  _c("h3", [_vm._v(_vm._s(_vm.t("cookbook", "Instructions")))]),
                  _vm._v(" "),
                  _c(
                    "ol",
                    { staticClass: "instructions" },
                    _vm._l(
                      _vm.recipe.instructions,
                      function (instruction, idx) {
                        return _c("RecipeInstruction", {
                          key: "instr" + idx,
                          attrs: { instruction: instruction },
                        })
                      }
                    ),
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }